const TilesLoadedMessage = () => {
  return (
    <div className='d-flex justify-content-center p-4  align-items-center'>
      <span
        className='title title__normal pe-2'
        style={{ color: '#52c41a' }}>
        ✓
      </span>
      <span className='title title__normal title__grey '>
        You're all caught up!
      </span>
    </div>
  );
};
export default TilesLoadedMessage;
